var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form',_vm._g(_vm._b({ref:"form",on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.isPreventFormSubmit.apply(null, arguments)}}},'b-form',_vm.props,false),_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }